<template>
    <!-- 会员中心 -->
    <div  class="Booking">
        <TopNavigation  class="topNavigation"></TopNavigation>
        <div class="typeArea">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item class="bread">会员中心</el-breadcrumb-item>
            </el-breadcrumb>

            <div class="content">
                <div class="user">
                    <div class="zuo">
                        <el-avatar :src="userInfo.avatar"  icon="el-icon-user-solid"></el-avatar>
                        <div>
                            <div class="name">
                                {{userInfo.nickname}}
                            </div>
                            <div class="idd">
                                用户ID：{{userInfo.sn}}
                            </div>
                        </div>
                    </div>
                    <div>
                        <button class="duihuan" v-show="bindtotal!=0" @click="bangdingXin">绑定新用户</button>
                        <button class="xufei" @click="$router.push('/OpenMembership')">续费</button>
                    </div>
                </div>

                <div class="vip">
                    <div class="one gong">
                        <div>会员类型</div>
                        <div class="xia">
                            <div v-if="is_vip==1">普通会员</div>
                            <div v-if="is_vip==2">订舱宝会员</div>
                        </div>
                    </div>
                    <div class="two gong">
                        <div>到期时间</div>
                        <div class="xia">{{vip_expire_time}}</div>
                    </div>
                    <div class="three gong">
                        <div>绑定用户（{{bindcount}}/{{bindtotal}}）</div>
                        <div class="xia">
                            
                            <el-button class="chakan" @click=" dialogVisible = true" type="text">查看列表</el-button>
                            <span>丨</span>
                            <el-button type="text" @click="$router.push('/OpenMembership')">增加绑定数量</el-button>
                        </div>
                    </div>
                </div>

                <div class="minmgxi">
                    <div class="tit">会员明细</div>
                    <el-table
                        :data="vipList"
                        style="width: 100%"
                        :header-cell-style="{ background: '#f9f9f9' }"
                    >
                        <el-table-column prop="order_sn" label="订单编号">
                            <template slot-scope="scope">
                                <span>{{scope.row.order_sn || '--'}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="vip_type" label="会员类型">
                            <template slot-scope="scope">
                                <span v-if="scope.row.vip_type==1">普通会员</span>
                                <span v-if="scope.row.vip_type==2">订舱宝会员</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="type" label="开通方式">
                            <template slot-scope="scope">
                                <span v-if="scope.row.type==0">新用户赠送</span>
                                <span v-if="scope.row.type==1">购买</span>
                                <span v-if="scope.row.type==2">企业团购绑定</span>
                                <span v-if="scope.row.type==3">供应商开通会员绑定</span>
                                <span v-if="scope.row.type==4">邀请赠送</span>
                                <span v-if="scope.row.type==5">老用户赠送</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="pay_type" label="支付方式">
                            <template slot-scope="scope">
                                <span v-if="scope.row.pay_type==1">对公转账</span>
                                <span v-else-if="scope.row.pay_type==2">余额支付</span>
                                <span v-else>--</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="actual_paid" label="金额"> </el-table-column>
                        <el-table-column prop="create_time" label="生效时间"> </el-table-column>
                    </el-table>

                    <!-- 分页 -->
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="form.page_no"
                        :page-sizes="[10, 15, 25, 50]"
                        :page-size="form.page_size"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="vipListTotal">
                        </el-pagination>
                </div>
            </div>
        </div>

        <!-- 绑定新用户 -->
        <el-dialog class="dialog" title="绑定新用户" :visible.sync="dialogFormVisible">
            <el-form>
                <el-form-item label="手机号：">
                    <!-- <el-input placeholder="请输入" v-model="redemption_code" autocomplete="off"></el-input> -->
                    <el-select
                        clearable
                        v-model="memberForm.redemption_user_id"
                        filterable
                        remote
                        reserve-keyword
                        placeholder="请输入手机号"
                        :remote-method="remoteMethod"
                        :loading="loading">
                        <el-option
                        v-for="item in phoneList"
                        :key="item.user_id"
                        :label="item.nickname+'-'+item.mobile"
                        :value="item.user_id">
                        </el-option> 
                    </el-select>
                </el-form-item>
                <el-form-item label="邮箱地址：">
                    <el-input  @blur="validEmsil" clearable placeholder="请输入邮箱地址" v-model="memberForm.email" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addBindUserVip">绑 定</el-button>
            </div>
        </el-dialog>

        <!-- 管理会员账号 -->
        <el-dialog title="管理会员账号" :visible.sync="dialogVisible">
            <el-table
                :data="vipRedemptionCodeList"
                style="width: 100%"
                :header-cell-style="{ background: '#f9f9f9' }"
            >
                <el-table-column prop="nickname" label="名称"> </el-table-column>
                <el-table-column prop="mobile" label="手机号"> </el-table-column>
                <el-table-column prop="email" label="邮箱地址"> </el-table-column>
                <el-table-column prop="redemption_time" label="添加时间"> </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button class="del" type="text" @click="delManageI(scope.row)" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <el-pagination
            v-show="dialogTotal>0"
            @size-change="handleSizeChangeDialog"
            @current-change="handleCurrentChangeDialog"
            :current-page="dialogForm.page_no"
            :page-sizes="[10, 15, 25, 50]"
            :page-size="dialogForm.page_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="dialogTotal">
            </el-pagination> -->
            <div class="add"  v-show="bindtotal!=0" @click="bangdingXin">
                <i class="el-icon-circle-plus-outline"></i>添加账号
            </div>
        </el-dialog>
    </div>
</template>
    
<script>
import TopNavigation from "../HP/TopNavigationB.vue";
import { useVipList,searchUser,useVipRedemptionCodeList,userdeleteBindUserVip,redemption } from "@/api/api";
export default {
    components:{
        TopNavigation,
    },
    data() {
        return {
            currentPage:1,
            // 兑换码弹窗状态
            dialogFormVisible: false,
            dialogVisible: false,
            headers: {
                token: localStorage.getItem("token"),
            },
            // 会员明细
            vipList:[],
            vipListTotal:0,
            // 会员兑换码列表
            vipRedemptionCodeList:[],
            vipRedemptionCodeListTotal:0,
            // 绑定新用户
            memberForm:{
                redemption_user_id:'',
                email:'',
            },
            // 获取用户信息
            userInfo:JSON.parse(localStorage.getItem('userInfo')),
            form:{
                page_no:1,
                page_size:10,
            },
            loading: false,
            phoneList:[],
            dialogForm:{
                page_no:1,
                page_size:10,
            },
            dialogTotal:0,
            bindtotal:0,
            bindcount:0,
            vip_expire_time:'--',
            is_vip:0,
        }
    },
    methods: {
        // 校验邮箱
        validEmsil(e) {
            let emial = e.target.value
            if(emial==''){
                return
            }
            if (emial == "" || emial == undefined) {
                this.$message({
                message: "请输入邮箱地址",
                type: "error",
                });
                return false;
            } else if (
                !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                emial
                )
            ) {
                this.$message({
                // duration:0,
                message: "请输入正确的邮箱地址",
                type: "error",
                });
                return false;
            }
            return true;
        },
        handleSizeChange(val) {
            this.form.page_size=val
            this.getVipList()
        },
        handleCurrentChange(val) {
            this.form.page_no=val
            this.getVipList()
        },
        fuzhi(ind){
            navigator.clipboard.writeText(ind).then(() => {
                this.$message({
                    type:'success',
                    message:'复制成功'
                })
            }).catch(err => {
                console.error('复制失败: ', err);
                this.$message({
                    type:'error',
                    message:'复制失败'
                })
            });
        },
        async getVipList(){
            try {
                const res = await useVipList(this.form,this.headers)
                if(res.code==1){
                    this.vipList=res.data.lists
                    this.vipListTotal=res.data.count
                }
            } catch (error) {
                console.log(error,'获取会员列表失败');
            }
        },
        handleSizeChangeDialog(val) {
            this.dialogForm.page_size=val
            this.getVipRedemptionCodeList()
        },
        handleCurrentChangeDialog(val) {
            this.dialogForm.page_no=val
            this.getVipRedemptionCodeList()
        },
        // 获取绑定列表   绑定总数
        async getVipRedemptionCodeList(){
            try {
                const res = await useVipRedemptionCodeList(this.dialogForm,this.headers)
                if(res.code==1){
                    let data =[...res.data.lists]
                    // this.vipRedemptionCodeList=res.data.lists
                    for (let i = 0; i < data.length; i++) {
                        if(data[i].redemption_user_id>0){
                            this.vipRedemptionCodeList.push(data[i])
                        }
                    }
                    this.bindcount = res.data.bind
                    this.bindtotal = res.data.count
                    this.dialogTotal = res.data.count
                    this.vip_expire_time = res.data.vip_expire_time || '--'
                    this.is_vip = res.data.is_vip
                }
            } catch (error) {
                console.log(error,'获取会员列表失败');
            }
        },
        // 根据手机号搜索用户
        remoteMethod(query){
            if (query !== '') {
                this.loading = true;
                setTimeout(async () => {
                    this.loading = false;
                    
                    const res = await searchUser({
                        keyword:query,
                        page_no:1,
                        page_size:50,
                    },this.headers)
                    
                    if (res.code==1) {
                        this.phoneList=res.data.lists
                    }
                }, 200);
            }else{
                this.phoneList = [];
            }
        },
        // 添加会员权益列表数据
        async addBindUserVip(){
            try {
                const res = await redemption(this.memberForm,this.headers);
                if (res.code == 1) {
                    this.memberDialogVisible = false
                    this.$message({
                        type:'success',
                        message:'添加成功'
                    })
                    this.dialogFormVisible = false
                    // this.manageData = res.data.lists;
                    this.memberForm.redemption_user_id=''
                    this.memberForm.email=''
                }else{
                    this.$message({
                        type:'error',
                        message:res.msg
                    })
                }
            } catch (error) {
                console.log("失败");
            } 
        },
        async delManageI(e){
            try {
                // supplierRechargeConfig
                const res = await userdeleteBindUserVip({
                    code_id:e.code_id,
                },this.headers);
                if (res.code == 1) {
                    this.getRedemptionCodeList()
                    this.dialogVisible = false
                    this.$message({
                        type:'success',
                        message:'删除成功'
                    })
                }else{
                    this.$message({
                        type:'error',
                        message:res.msg
                    })
                }
            } catch (error) {
                console.log("失败");
            } 
        },
        bangdingXin(){
            if(this.bindcount == this.bindtotal){
                this.$message({
                    type:'error',
                    message:'用户绑定数量已达上限'
                })
                return
            }
            this.dialogFormVisible = true
        }
    },
    mounted(){
        this.getVipList()
        this.getVipRedemptionCodeList()
    }
}
</script>
    
<style style lang="scss" scoped>
.topNavigation{
    height: 100PX;
    display: flex;
    justify-content: space-between;
    padding: 0 80px;
    background: #fff;
}

.Booking{
    background: #F9F9F9;
}
.typeArea{
    width: 1200px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
}


.el-breadcrumb{
    margin: 20px 0;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    .el-breadcrumb__inner is-link{
        color: pink;
    }
}

:deep(.el-breadcrumb){
    .el-breadcrumb__inner{
        color: #999999 !important;
    }
    .bread{
        span{
            color: #0073F5 !important;
        }
    }
}

.content{
    padding: 32px;
    height: 900px;
    background: #FFFFFF;
    border-radius: 12px 12px 12px 12px;

    box-sizing: border-box;

    margin-bottom: 10px;

    .user{
        display: flex;
        justify-content: space-between;
        align-items: center;
    

        .zuo{
            display: flex;
            align-items: center;

            .el-avatar{
                width: 62px;
                height: 62px;
            }

            .name{
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 20px;
                color: #333333;
                font-style: normal;
                text-transform: none;
                margin-left: 12px;
                margin-bottom: 4px;
            }

            .idd{
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #999999;
                font-style: normal;
                text-transform: none;
                margin-left: 12px;
            }
        }

        .duihuan{
            width: 100px;
            height: 40px;
            border-radius: 8px 8px 8px 8px;
            border: 1px solid #0073F5;

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #0073F5;
            font-style: normal;
            text-transform: none;

            background: #fff;

            cursor: pointer;
        }

        .xufei{
            width: 80px;
            height: 40px;
            background: #0073F5;
            border-radius: 8px 8px 8px 8px;

            font-size: 16px;
            color: #FFFFFF;

            border: 0;

            cursor: pointer;

            margin-left: 25px;
        }
    }

    .vip{
        // 
        width: 1163px;
        height: 88px;

        background-image:url('../../assets/images/会员背景.png');	
        background-repeat: no-repeat;
        background-size:100% 100%;

        margin-top: 24px;
        padding: 20px 0;

        box-sizing: border-box;

        display: flex;
        .gong{
            margin-left: 48px;

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #999999;
            font-style: normal;
            text-transform: none;

            .xia{
                font-size: 16px;
                color: #333333;

                span{
                    color: #999999;
                }

                .el-button{
                    color: #0073F5;
                }

                .chakan{
                    margin-left: 12px;
                }
            }
        }
        .one{
            width: 400px;
            border-right: solid 1px #D9D9D9;
        }
        .two{
            width: 380px;
            border-right: solid 1px #D9D9D9;
        }
        .three{
            width: 253px;
        }
    }

    .minmgxi{
        
        margin-top: 32px;

        .tit{
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #333333;
            font-style: normal;
            text-transform: none;
            margin-bottom: 20px;
        }
    }
    
    
    .el-pagination{
        text-align: right;
        margin-top: 80px;
    }
}

.dialog{
    :deep(.el-dialog){
        width: 480px ;
        .el-form-item__content{
            display: flex;
        }
    }
    :deep(.el-input){
        width: 320px;
        height: 48px;
        input{
            width: 320px;
            height: 48px;
            background: #F9F9F9;
            border-radius: 8px 8px 8px 8px;
            border: 0;
        }
    }
}

.el-pagination{
    text-align: right;
    margin-top: 40px;
}

.table{
    width: 100%;
    border-spacing: 0;

    border-bottom: solid 1px #eee;

    margin-top: 4px;

    .theader{
        height: 48px;
        background: #F9F9F9;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        font-style: normal;
        text-transform: none;
    
    }
    .first{
        padding-left: 24px;
        // width: 320px;
    }
    .tbody{
        height: 68px;
        background: #fff;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        font-style: normal;
        text-transform: none;

        .el-button{
            color: #0073F5;
            font-size: 14px;
        }

        .del{
            color: #FE3300;
        }

        span{
            color: #999999;
            font-size: 14px;
        }
    }
}
.fuzhi{
    margin-left: 4px;
}

.add{
    cursor: pointer;
    margin-top: 24px;
    font-size: 14px;
    color: #0073F5;
    .el-icon-circle-plus-outline{
        font-size: 16px;
        margin-right: 8px;
    }
}
</style>